import { render, staticRenderFns } from "./sales-order-dialog.vue?vue&type=template&id=444a244b&"
import script from "./sales-order-dialog.vue?vue&type=script&lang=js&"
export * from "./sales-order-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports